import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  Validator,
} from "common";
import I18n from "i18n-js";
import {
  getOpenapiKeyService,
  OpenapiKeyFormItem,
  OpenapiKeyOptions,
} from "./openapiKeyApi";

export interface UseOpenapiKeyFormProps extends GridModalFormProps {}

export default function useOpenapiKeyForm({ id, afterSave }: UseOpenapiKeyFormProps) {
  const service = getOpenapiKeyService();

  const form = useForm<OpenapiKeyFormItem, OpenapiKeyOptions>({
    id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "OpenapiKey",
    defaultValues: {
      enabled: 1,
    },
    rules: {
      name: Validator.rule.any().required(),
    },
    afterSave: (newItem, isCreate) => {
      if (newItem.key) {
        globalMessageHandler.infoModal(I18n.t("OpenapiKey.apiKeyMessage", {key: newItem.key}));
      }

      afterSave?.(newItem, isCreate);
    },
    afterLoad: _newItem => {},
    onValidationFailed: () => {
      globalMessageHandler.error(I18n.t("App.formHasErrors"));
    },
    afterChange: (newItem, id, option) => {
      if (newItem.permissions) {
        let newPermission: string[] = newItem.permissions;
        const allOptions = form.options.permissions;

        newItem.permissions.forEach((value: string, index: number) => {
          const match = value.match(/^openapi(View|Add|Modify)(.+)$/);

          if (match && match[1] && match[2]) {
            const [type, permission] = [match[1], match[2]];

            if (type === "Modify" || type === "Add") {
              const otherPermissionValue = "openapiView" + permission;

              let otherTypeFound = false;
              allOptions.forEach((option) => {
                if (option.value === otherPermissionValue) {
                  otherTypeFound = true;
                }
              });

              if (otherTypeFound && !newItem.permissions.includes(otherPermissionValue)) {
                newPermission.push(otherPermissionValue);
              }
            }
          }
        });

        form.setAttributes({
          permissions: newPermission,
        });
      }

    },
    ...service,
  });

  return form;
}
